import { Text } from './Text';

export interface MenuItemTileProps {
  onClick: () => void;
  label: string;
  textColor?: string;
  hoverBackgroundColor?: string;
}

function MenuItemTile({
  onClick,
  label,
  textColor = 'var(--text-primary)',
  hoverBackgroundColor = '#e3e3e3'
}: MenuItemTileProps) {
  const baseStyle: React.CSSProperties = {
    width: '100%',
    padding: '8px',
    border: 'none',
    background: 'none',
    textAlign: 'left',
    cursor: 'pointer',
    borderRadius: '8px',
    boxSizing: 'border-box'
  };

  return (
    <button
      onClick={onClick}
      style={baseStyle}
      onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = hoverBackgroundColor)}
      onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = 'transparent')}
    >
      <Text variant='body2-medium' style={{ color: textColor }}>
        {label}
      </Text>
    </button>
  );
}

export default MenuItemTile;
